import MuiMenuItem, { MenuItemProps } from '@material-ui/core/MenuItem';

export type DSMenuItemProps = MenuItemProps & { ['data-cy']?: string };

export const DSMenuItem: typeof MuiMenuItem & { displayName?: string } = MuiMenuItem;
DSMenuItem.displayName = 'DSMenuItem';
